import React from 'react'
import PropTypes from 'prop-types'
import {getPriceData} from '@salesforce/retail-react-app/app/utils/product-utils'
import DisplayPrice from '~/app/components/display-price'

const getPrices = (product) => {
    const tieredPrices = product.tieredPrices
    let salePrice = null
    let listPrice = null

    if (tieredPrices?.length === 1) {
        salePrice = tieredPrices[0].price
    } else if (tieredPrices?.length === 2) {
        const tiredPrice1 = tieredPrices[0].price
        const tiredPrice2 = tieredPrices[1].price

        if (tiredPrice1 === tiredPrice2) {
            salePrice = tiredPrice1
        } else if (tiredPrice1 < tiredPrice2) {
            salePrice = tiredPrice1
            listPrice = tiredPrice2
        } else {
            salePrice = tiredPrice2
            listPrice = tiredPrice1
        }
    }

    return {
        salePrice,
        listPrice
    }
}

/**
 * In the context of a cart product item variant, this component renders the item's
 * pricing, taking into account applied discounts as well as base item prices.
 */
const ProductPrice = ({currency, product}) => {
    const variant = product?.variant || product
    const {basePrice} = variant
    const isASet = variant?.type?.set
    const isMaster = variant?.type?.master
    let priceData
    // When variant has basket pricing, we should prioritize these prices for displaying
    // since they may have take promotion/discount into account
    // NOTE: try NOT to re-calculate these values since basket-level discount is complicated
    if (variant?.itemId) {
        const {salePrice, listPrice} = getPrices(variant)
        priceData = {
            currentPrice: basePrice || 0,
            listPrice: listPrice,
            pricePerUnit: basePrice,
            isASet,
            isMaster,
            isRange: isASet || isMaster || false,
            isOnSale: !!(salePrice && listPrice && salePrice < listPrice)
        }
    } else {
        // for wishlist page we extract price info from variant/product obj
        priceData = getPriceData(variant)
    }

    return (
        <div
            className="[&>div]:flex [&>div]:flex-col-reverse
            [&_s]:text-[1rem]/[1.5rem] [&_s]:font-light [&_s]:font-grotesque font-light [&_s]:text-gray-03
            [&_b]:text-[1rem]/[1.5rem] [&_b]:font-medium [&_b]:font-grotesque [&_b]:text-accent"
        >
            {variant?.itemId ? (
                <DisplayPrice
                    labelForA11y={variant?.name}
                    currency={currency}
                    priceData={priceData}
                    listPriceProps={{fontSize: 'sm'}}
                    data-testid="productPrice-DisplayPrice"
                />
            ) : (
                <DisplayPrice
                    labelForA11y={variant?.name}
                    currency={currency}
                    priceData={priceData}
                    quantity={variant?.quantity}
                    listPriceProps={{fontSize: 'sm'}}
                    data-testid="productPrice-DisplayPrice"
                />
            )}
        </div>
    )
}

ProductPrice.propTypes = {
    currency: PropTypes.string.isRequired,
    product: PropTypes.object.isRequired
}

export default ProductPrice
